import React, { useState } from "react";
import { Row, Col, Typography, Button, Menu, Dropdown, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import logo from "../assets/logo.png";
import propertyImage from "../assets/property.png";
import CommonFooter from "../components/common/CommonFooter";
import { useNavigate, Link } from "react-router-dom";
import InstantCallModal from "../components/common/InstantCallModal";

const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

const ListingPoliciesPage = () => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [menuVisible, setMenuVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleProceed = () => {
    navigate("/list");
  };

  const handleInstantCallClick = (e) => {
    e.preventDefault();
    setMenuVisible(false);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const menu = (
    <Menu
      theme="dark"
      style={{
        background: "rgba(0, 0, 0, 0.95)",
        color: "#fff",
        padding: screens.xs ? "8px 16px" : "10px 25px",
        borderRadius: "6px",
        minWidth: screens.xs ? "200px" : "250px",
      }}
      items={[
        {
          key: "0",
          label: (
            <Link
              to="/"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Home
            </Link>
          ),
        },
        {
          key: "1",
          label: (
            <Link
              to="/about-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Who We Are
            </Link>
          ),
        },
        {
          key: "2",
          label: (
            <Link
              to="/listed-property"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Our Offerings
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link
              to="/work"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              How NITM Works
            </Link>
          ),
        },
        {
          key: "4",
          label: (
            <Link
              to="/policy"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              List Your Property
            </Link>
          ),
        },
        {
          key: "5",
          label: (
            <Link
              to="/news-room"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              News Room
            </Link>
          ),
        },
        {
          key: "6",
          label: (
            <Link
              to="/contact-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Contact Us
            </Link>
          ),
        },
        {
          key: "7",
          label: (
            <Link
              to="/our-story"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Our Story
            </Link>
          ),
        },
        // Instant Call Button - Added from common header
        {
          key: "instant-call",
          label: (
            <div
              onClick={handleInstantCallClick}
              style={{
                color: "#EDC71C",
                padding: "12px 16px",
                marginTop: "10px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: screens.xs ? "12px" : "14px",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Instant Call
            </div>
          ),
        },
      ]}
    />
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f0f0f0" }}>
      <Row style={{ minHeight: "100vh" }}>
        {/* Left Image Section */}
        {screens.md && (
          <Col md={12} style={{ position: "relative" }}>
            <img
              src={propertyImage}
              alt="Property"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: screens.xs ? "12px" : "0 0 140px 0",
              }}
            />
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{ position: "absolute", top: 20, left: 20, height: 40 }}
              />
            </Link>
          </Col>
        )}

        {/* Right Section */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#f0f0f0",
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              width: "100%",
              background: "#DDC7BB",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: screens.xs ? "60px" : "80px",
            }}
          >
            <Title
              level={4}
              style={{ margin: "0 20px", color: "#000" }}
            ></Title>

            <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={screens.xs ? ["click"] : ["hover"]}
              open={menuVisible}
              onOpenChange={setMenuVisible}
            >
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#8f8c8c",
                  padding: screens.xs ? "0 12px" : "0 16px",
                  cursor: "pointer",
                }}
              >
                <MenuOutlined
                  style={{
                    color: "#fff",
                    fontSize: screens.xs ? 16 : 20,
                  }}
                />
              </div>
            </Dropdown>
          </div>

          {/* Listing Policies Content */}
          <div
            style={{
              marginTop: 40,
              width: "100%",
              maxWidth: 600,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: screens.xs ? "0 20px" : "0 40px",
            }}
          >
            <Title
              level={screens.xs ? 3 : 2}
              style={{
                color: "#000",
                marginBottom: 20,
                fontSize: screens.xs ? "24px" : "32px",
              }}
            >
              Listing Policies
            </Title>

            <div style={{ width: "100%" }}>
              <Paragraph style={{ fontSize: screens.xs ? 14 : 16 }}>
                <Text strong>
                  Step 1: Initial Submission (Basic information)
                </Text>
                <br />• Property type, location, and size
                <br />• Ownership status (individual, company, or
                representative)
                <br />• Whether the property is listed on any other platform
              </Paragraph>

              <Paragraph style={{ fontSize: screens.xs ? 14 : 16 }}>
                <Text strong>Step 2: Identity & Authority Verification</Text>
                <br />• Who are you? (Owner, Broker, Private Office, or
                Authorized Representative)
                <br />• If you are a broker:
                <br />
                 - Do you have direct access to the entity or owner?
                <br />
                 - Do you hold a valid mandate or authorization letter to list
                or sell on their behalf?
              </Paragraph>

              <Paragraph style={{ fontSize: screens.xs ? 14 : 16 }}>
                <Text strong>Step 3: Required Documents</Text>
                <br />• Proof of ownership or title deed copy
                <br />• Valid ID or company trade license
                <br />• Authorization letter (if represented by a broker or
                third party)
                <br />• Property details and supporting visuals (if permitted by
                the owner)
              </Paragraph>

              <Paragraph style={{ fontSize: screens.xs ? 14 : 16 }}>
                <Text strong>Step 4: Verification & Approval</Text>
                <br />• Our team verifies documents and ownership before
                activating the listing.
                <br />• Only verified listings appear publicly.
                <br />• Sensitive details are shared privately upon verified
                expressions of interest.
              </Paragraph>
            </div>

            {/* Centered Button */}
            <Button
              type="primary"
              style={{
                marginTop: 30,
                background: "#000",
                color: "#fff",
                padding: screens.xs ? "12px 0" : "14px 0",
                width: "80%",
                maxWidth: 350,
                border: "none",
                borderRadius: 6,
                fontWeight: 500,
                fontSize: screens.xs ? "14px" : "16px",
                height: screens.xs ? "44px" : "48px",
              }}
              onClick={handleProceed}
            >
              PROCEED TO LIST
            </Button>
          </div>
        </Col>
      </Row>

      <CommonFooter />

      <InstantCallModal
        visible={isModalVisible}
        onClose={handleModalClose}
        propertyId={null} 
      />
    </div>
  );
};

export default ListingPoliciesPage;
